// extracted by mini-css-extract-plugin
export default {"productGrid":"uZ-z","centerLink":"vZ-z","productSection":"wZ-z","item":"xZ-z","ctaButton":"yZ-z"};